module.exports = __webpack_public_path__ + "img/17867_S.2b202737.png";